// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"1ff3fcb7","455":"ec22820a","977":"ca3ec96e"}[chunkId] + ".chunk.js";
};